<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>

import searcherryStore from '@/services/Searcherry/SearcherryStore'
import { Vue } from 'vue-property-decorator'

export default class App extends Vue {
  globalStore = searcherryStore
}

</script>
<style lang="scss">
  @import './assets/css/main.scss';
</style>
